import { useStore } from "../Store";

export function useWipeData() {
  const {
    setAccess,
    setToken,
    setSessionDetails,
    setLoading,
    setShowPopup,
    setShowPopupError,
    setPopupErrorMessage,
    setSelectedDataHolder,
    setSelectedConsent,
    setData,
    setIsEmbedded,
  } = useStore();

  return function WipeData() {
    setAccess(false);
    setData(null);
    setLoading(false);
    setPopupErrorMessage("");
    setSelectedConsent(null);
    setSelectedDataHolder(null);
    setSessionDetails(null);
    setShowPopup(false);
    setShowPopupError(false);
    setToken(null);
    setIsEmbedded(false);

    sessionStorage.clear();
    localStorage.clear();
  };
}
